const getCollectionUrl = `https://shopify-collection-snapshot.casday-workers.workers.dev`;
//`https://shopify-collection-snapshot.yuichi86hama49.workers.dev`;


document.addEventListener('DOMContentLoaded', () => {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
    const productRoot = document.getElementById('cf-collection-root');
    const paginationRoot = document.getElementById('cf-pagination-root');
    const newArrivalsList = document.getElementById('js-newarrivals');
    const hasCollectionRoot = !!(productRoot && paginationRoot);
    const hasNewArrivals = !!(newArrivalsList && newArrivalsList.dataset.collectionHandle);
    if (!hasCollectionRoot && !hasNewArrivals) return;

    let current_page = 1;
    let loadProducts = null;

    function renderProducts(root, products, options = {}) {
        const renderedItems = root.querySelectorAll('[data-code]');
        const maxUniqueCount = Number(options.maxUniqueCount || 12);
        const excludeOutOfStock = Boolean(options.excludeOutOfStock);

        // 最初からデコード済みの値でSetを作る
        const uniqueHandles = new Set();
        const existingCodes = new Set();

        for (const el of renderedItems) {
            // data-codeをデコードして取得
            const decodedCode = normalizeCode(el.dataset.code);
            existingCodes.add(decodedCode);
            console.log(decodedCode);
            // handle部分だけを抽出して種類数をカウント
            // 例: "handle_color" の "handle" 部分
            const handle = decodedCode.split('_')[0];
            uniqueHandles.add(handle);
        }

        let currentCount = uniqueHandles.size;
        const addItems = [];

        for (const p of products) {
            if (currentCount >= maxUniqueCount) break;
            if (excludeOutOfStock && (p.available === 0 || p.available === false)) {
                continue;
            }

            // APIの結果から比較用のcodeを生成（デコード済みの姿）
            const code = p.color && p.color != 'default' ? `${p.handle}_${p.color}` : p.handle;
            const decodedHandle = normalizeCode(p.handle);
            const decodedColor = (p.color && p.color !== 'default') ? normalizeCode(p.color) : null;

            const decodedCode = decodedColor ? `${decodedHandle}_${decodedColor}` : decodedHandle;
            // 両方デコード済みなので、ここで確実に一致する
            if (existingCodes.has(decodedCode)) {
                continue;
            }

            // URL生成（ここは要件通りエンコードが必要）
            const encodedColor = encodeURIComponent(p.color).replace(/%20/g, '+');
            const product_url = `/products/${p.handle}${p.colors_count > 1 ? `?color=${encodedColor}` : ''}`;

            // HTML生成処理...
            const releaseTs = parseReleaseTimestamp(p);
            const html = collection_card(
                escapeHtml(p.title),
                escapeHtml(p.brand),
                code, // ここで渡すcodeはAPI由来の( )付き。もしHTML出力時に自動でエンコードされるならそのままでOK
                Number(p.price || 0),
                p.compare_at_price ? Number(p.compare_at_price) : null,
                p.colors_count || 0,
                product_url,
                p.image_url,
                p.available == 0,
                pickHoverImageUrl(p, p.image_url),
                releaseTs
            );

            addItems.push(html);
            existingCodes.add(decodedCode);

            if (!uniqueHandles.has(p.handle)) {
                uniqueHandles.add(p.handle);
                currentCount++;
            }
        }

        if (addItems.length > 0) {
            root.insertAdjacentHTML('beforeend', addItems.join(''));
            if (typeof applyListProductImageFit === 'function') {
                applyListProductImageFit(root);
            }
        }
    }
    function renderPagination(root, currentPage, totalPages) {
        if (totalPages <= 1) {
            root.innerHTML = '';
            return;
        }

        let html = `<nav aria-label="Page navigation" class="pagenation">`;

        // 前へ
        if (currentPage > 1) {
            html += `<span class="prev"><a data-page="${currentPage - 1}">Prev</a></span>`;
        }

        const range = 3;
        const start = Math.max(1, currentPage - range);
        const end = Math.min(totalPages, currentPage + range);

        function pageItem(i) {
            return `
          <span class="page ${i === currentPage ? 'current' : ''}">
              <a data-page="${i}">${i}</a>
          </span>`;
        }

        // --- 1ページ目 ---
        if (start > 1) {
            html += pageItem(1);
            if (start > 2) {
                html += `<span class="dots">...</span>`;
            }
        }

        // --- 中央範囲 ---
        for (let i = start; i <= end; i++) {
            html += pageItem(i);
        }

        // --- 最終ページ ---
        if (end < totalPages) {
            if (end < totalPages - 1) {
                html += `<span class="dots">...</span>`;
            }
            html += pageItem(totalPages);
        }

        // 次へ
        if (currentPage < totalPages) {
            html += `<span class="next"><a data-page="${currentPage + 1}">Next</a></span>`;
        }

        html += `</nav>`;

        root.innerHTML = html;
    }
    document.addEventListener('click', async (e) => {
        if (e.target.matches('[data-page]')) {
            if (!hasCollectionRoot || typeof loadProducts !== 'function') return;
            const page = Number(e.target.dataset.page);
            const currentState = history.state || {};
            history.replaceState(
                { ...currentState, page: current_page, scrollY: window.scrollY },
                '',
                window.location
            );
            await loadProducts(page);

            // URLを書き換える（リロードなし）
            const url = new URL(window.location);
            url.searchParams.set('page', page);
            history.pushState({ page, scrollY: 0 }, '', url);

            const target = document.querySelector('.title-section');
            if (target) {
                const headerOffset = 100;
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    });

    window.addEventListener('popstate', async (e) => {
        if (!hasCollectionRoot || typeof loadProducts !== 'function') return;

        const params = new URLSearchParams(location.search);
        const state = e.state || {};
        const page = Number(state.page) || Number(params.get('page')) || 1;

        // 1. 透明度を下げてロード中であることを示す
        productRoot.style.opacity = '0.5';
        productRoot.style.transition = 'opacity 0.2s';

        // 2. データのロードと描画を待つ
        await loadProducts(page);

        // 3. スクロール位置の調整
        // ブラウザのデフォルトのスクロール復元を無効化したい場合は 
        // history.scrollRestoration = 'manual'; を DOMContentLoaded 等で設定しておくのが理想的です

        requestAnimationFrame(() => {
            const target = document.querySelector('.title-section');
            if (target) {
                const headerOffset = 100;
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'auto' // ブラウザバック時は auto の方がストレスが少ないです
                });
            }
            // 4. 全て終わったら不透明度を戻す
            productRoot.style.opacity = '1';
        });
    });


    async function fetchCollectionProducts({
        handle,
        tags,
        page = 1,
        pageSize = 12,
        sortBy = 'default'
    }) {
        const res = await fetch(
            `${getCollectionUrl}/api/collection-products?page=${page}&page_size=${pageSize}&sort_by=${sortBy}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Api-Token': '8Sti2Jxh1brPOHPJjOXqjKLwr1R6UE'
                },
                body: JSON.stringify({
                    collectionHandle: handle,
                    tags
                })
            }
        );
        if (!res.ok) {
            console.error('CF API error');
            return null;
        }
        return res.json();
    }

    if (hasCollectionRoot) {
        const sortBy = new URLSearchParams(location.search).get('sort_by') || 'default';
        const useApiOrder = sortBy === 'price-ascending' || sortBy === 'price-descending' || sortBy === 'created-descending';
        current_page = new URLSearchParams(location.search).get('page') || 1;
        loadProducts = async function loadProducts(page = 1) {

            const handle = productRoot.dataset.collectionHandle;
            const ul = productRoot.querySelector('ul.list-products');
            const initialElements = ul.querySelectorAll('.initial_item');
            const isLoadPage = current_page == page;

            const segments = location.pathname.split('/').filter(Boolean);

            const collectionsIndex = segments.indexOf('collections');

            let tags = [];

            if (collectionsIndex !== -1 && segments[collectionsIndex + 2]) {
                tags = segments[collectionsIndex + 2]
                    .split('+')
                    .map(t => t.toLowerCase());
            }
            const data = await fetchCollectionProducts({
                handle,
                tags,
                page,
                pageSize: 12,
                sortBy
            });
            if (!data) return;

            const currentCount = ul.querySelectorAll('[data-code]').length;

            if (useApiOrder || !isLoadPage) {
                ul.innerHTML = '';
                renderProducts(ul, data.products, { maxUniqueCount: 12 });
                if (Number(page) === 1 && data.products.length === 0) {
                    const notFoundHtml = `<p>条件に一致するアイテムが見つかりませんでした。別の条件で再度検索してください。</p>`;
                    productRoot.innerHTML = notFoundHtml;
                }
            } else if (currentCount < 12) {
                //list-products__item skeletonを消す
                const skeletons = ul.querySelectorAll('.list-products__item.skeleton');
                skeletons.forEach(s => s.remove());
                renderProducts(ul, data.products, { maxUniqueCount: 12 });
                if (current_page == 1 && data.products.length == 0 && currentCount == 0) {

                    const notFoundHtml = `<p>条件に一致するアイテムが見つかりませんでした。別の条件で再度検索してください。</p>`;
                    productRoot.innerHTML = notFoundHtml;
                }
            }
            current_page = page;
            //ページネーションは常にレンダリング
            renderPagination(
                paginationRoot,
                data.page,
                Math.ceil(data.total / data.page_size)
            );
        }

        function init() {
            const params = new URLSearchParams(location.search);
            const ul = productRoot.querySelector('ul.list-products');
            const pageParam = params.get('page');
            const page = Number(pageParam) || 1;

            if (page > 1) {
                ul.innerHTML = '';
                ul.insertAdjacentHTML('beforeend', generateSkeleton(12));
            } else {
                // 1ページ目は、APIが返るまで純正を見せる。価格順と新着順は取得後にAPIの並びへ差し替える
                const initialElements = ul.querySelectorAll('.initial_item');
                initialElements.forEach(element => {
                    element.style.visibility = 'visible';
                });
                if (!useApiOrder && 12 - initialElements.length > 0) {
                    ul.insertAdjacentHTML('beforeend', generateSkeleton(12 - initialElements.length));
                }
            }
            loadProducts(page);

        }
        init();
    }

    if (hasNewArrivals) {
        (async () => {
            const handle = newArrivalsList.dataset.collectionHandle;
            const maxUniqueCount = Number(newArrivalsList.dataset.maxHandles || 40);
            const data = await fetchCollectionProducts({
                handle,
                tags: [],
                page: 1,
                pageSize: maxUniqueCount,
                sortBy: 'default'
            });
            if (!data) return;

            renderProducts(newArrivalsList, data.products, {
                maxUniqueCount,
                excludeOutOfStock: true
            });
        })();
    }
});

function generateSkeleton(count) {
    let html = '';
    for (let i = 0; i < count; i++) {
        html += `
        <li class="list-products__item skeleton">
            <div class="img"></div>
            <div class="text"></div>
        </li>`;
    }
    return html;
}
function pickHoverImageUrl(product, imageUrl) {
    const candidates = [
        product.hover_image_url,
        product.image_url_2,
        product.secondary_image_url
    ];
    for (const src of candidates) {
        if (src && src !== imageUrl) return src;
    }

    const images = product.images;
    if (!Array.isArray(images) || images.length < 2) return '';

    const normalize = (src) => String(src || '').split('?')[0];
    const current = normalize(imageUrl);
    const list = images.map((img) => (
        typeof img === 'string' ? img : (img && (img.src || img.url || img.image_url)) || ''
    )).filter(Boolean);

    const idx = list.findIndex((src) => {
        const normalized = normalize(src);
        return normalized === current || normalized.includes(current) || current.includes(normalized);
    });

    if (idx >= 0 && list[idx + 1]) return list[idx + 1];
    const wrap = list.find((src, i) => i !== idx && normalize(src) !== current);
    return wrap || '';
}

function parseReleaseTimestamp(product) {
    const raw = product.release_at
        || product.release_ts
        || product.releaseAt
        || (product.metafields && product.metafields.custom && product.metafields.custom.release_at);
    if (raw == null || raw === '') return 0;

    if (typeof raw === 'number') {
        return raw > 1e12 ? Math.floor(raw / 1000) : raw;
    }

    const str = String(raw.value || raw);
    if (/^\d+$/.test(str)) {
        const n = Number(str);
        return n > 1e12 ? Math.floor(n / 1000) : n;
    }

    const date = new Date(str.replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
    if (Number.isNaN(date.getTime())) return 0;
    return Math.floor(date.getTime() / 1000);
}

const collection_card = (
    title,
    brand,
    code,
    price,
    compare_price,
    color_length,
    url,
    image_url,
    is_soldout,
    hover_image_url,
    release_ts
) => {

    let price_switch = '';

    if (is_soldout && compare_price) {
        price_switch = `
      <p class="list-products__item__price">¥${compare_price.toLocaleString()}</p>
    `;
    } else if (compare_price && price < compare_price) {
        price_switch = `
      <p class="list-products__item__price">
        <span class="list-products__item__price__compare">¥${compare_price.toLocaleString()}</span>
        →
        <span class="list-products__item__price__sale">¥${price.toLocaleString()}</span>
      </p>`;
    } else {
        price_switch = `
      <p class="list-products__item__price">¥${price.toLocaleString()}</p>
    `;
    }

    const hoverImage = hover_image_url && hover_image_url !== image_url
        ? `
          <img
            class="list-products__item__image list-products__item__image--hover"
            src="${hover_image_url}"
            alt="${title}"
            loading="lazy"
          >`
        : '';
    const isUnreleased = Number(release_ts) > 0 && Date.now() < Number(release_ts) * 1000;
    const comingSoonLabels = isUnreleased
        ? `<p class="list-products__item__labels js-coming-soon-badge" data-release-ts="${release_ts}">
            <span class="list-products__item__label list-products__item__label--new">NEW</span>
            <span class="list-products__item__label list-products__item__label--coming-soon">COMING SOON</span>
          </p>`
        : '';

    return `
    <li class="list-products__item ${is_soldout ? 'is_soldout' : ''}" data-available="true" data-code="${code}">
      <a href="${url}">
        ${comingSoonLabels}
        <figure${hoverImage ? ' class="has-hover-image"' : ''}${isUnreleased ? ` data-release-ts="${release_ts}"` : ''}>
          <img class="list-products__item__image js-card-image-fit" src="${image_url}" alt="${title}" loading="lazy">
          ${hoverImage}
        </figure>
        <div class="list-products__item__text">
          <p class="list-products__item__brand">${brand}</p>
          <p class="list-products__item__title">${title}</p>
          ${price_switch}
          <p class="list-products__item__colors">${color_length} Colors</p>
        </div>
      </a>
    </li>
  `;
};

function escapeHtml(str) {
    return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function normalizeCode(code) {
    if (!code) return '';
    
    let decoded = code;
    try {
        // %が含まれている場合のみデコードを試みる
        if (code.includes('%')) {
            decoded = decodeURIComponent(code);
        }
    } catch (e) {
        // %が含まれていても、形式が不正でデコードできない場合は
        // そのままの文字列を使用する（URIErrorを回避）
        decoded = code;
    }

    return decoded
        .replace(/\+/g, ' ')  // URLのクエリパラメータなどで + がスペース扱いの場合への対応
        .replace(/\s+/g, ' ') // 連続する空白を1つにまとめる
        .trim()
        .toLowerCase();
}